import { localStorageHelper } from 'barnyard/utils';
import { LOCAL_STORAGE_VENDOR_FORM, LOCAL_STORAGE_PROFILE_FORM } from '../constants';

export const clearLocalStorages = () => {
  localStorageHelper.clear(LOCAL_STORAGE_PROFILE_FORM);
  localStorageHelper.clear(LOCAL_STORAGE_VENDOR_FORM);
};
